import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

import { AzureDevOpsProjectPicker } from './AzureDevOpsProjectPicker';

export const AzureDevOpsProjectPickerFieldExtension = FormFieldBlueprint.make({
  name: 'azure-devops-project-picker',

  params: {
    field: async () =>
      createFormField({
        name: 'AzureDevOpsProjectPicker',
        component: AzureDevOpsProjectPicker,
      }),
  },
});
